import { UserEntity } from '@/domains/User';
import Inputmask from 'inputmask';
import { Mask } from '@/constants';
import { formatExistValue, toUpperCaseFormatter } from '@/utils/common';

class UserAdapter {
  formatMobilePhone(phone: string) {
    return Inputmask.format(phone, {
      mask: Mask.PHONE,
    });
  }

  toInternal(user: UserEntity): UserEntity {
    return {
      ...user,
      roleType: formatExistValue(user.roleType, toUpperCaseFormatter, ''),
      contactInfo: {
        ...user.contactInfo,
        mobilePhone: formatExistValue(
          user.contactInfo.mobilePhone,
          this.formatMobilePhone,
          ''
        ),
      },
      roleDetails: user.roleDetails.map((roleDetail) => ({
        ...roleDetail,
        type: roleDetail.type.toUpperCase(),
      })),
    };
  }
}

export const userAdapter = new UserAdapter();
